import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface geofenceState {
	isLoading: boolean;
	geofenceList: any;
	totalgeofenceList: number;
	geofenceDetail: any;
}

const initialState: geofenceState = {
	isLoading: false,
	geofenceList: [],
	totalgeofenceList: 0,
	geofenceDetail: {}
};

const geofenceSlice = createSlice({
	name: 'geofences',
	initialState,
	reducers: {
		getAllGeofenceListInIt: state => {
			state.isLoading = true;
		},
		getAllGeofenceListSuccess: (state, action: PayloadAction<any>) => {
			const data = action.payload.data;
			state.isLoading = false;
			state.totalgeofenceList = data.count;
			state.geofenceList = data.geofencesList;
		},
		getAllGeofenceListError: state => {
			state.isLoading = false;
			state.geofenceList = [];
			state.totalgeofenceList = 0;
		},
		deleteGeofenceInit: state => {
			state.isLoading = true;
		},
		deleteGeofenceSuccess: state => {
			state.isLoading = false;
		},
		deleteGeofenceError: state => {
			// state.isLoading = false;
		},
		getGeofenceByIdInIt: state => {
			state.isLoading = true;
		},
		getGeofenceByIdSuccess: (state, action: PayloadAction<any>) => {
			console.log('action', action.payload.data);
			const data = action.payload.data.geofences;

			state.geofenceDetail = { ...data };
			state.isLoading = false;
		},
		getGeofenceByIdError: state => {
			state.isLoading = false;
		},
		addGeofenceInIt: state => {
			state.isLoading = true;
		},
		addGeofenceSuccess: state => {
			state.isLoading = false;
		},
		addGeofenceError: state => {
			state.isLoading = false;
		},
		clearGeofenceDetail: state => {
			state.geofenceDetail = {};
		},
		updateGeofenceStatusInit: state => {
			state.isLoading = true;
		},
		updateGeofenceStatusSuccess: state => {
			// state.isLoading = true;
		},
		updateGeofenceStatusError: state => {
			state.isLoading = false;
		}
	}
});

export const {
	getAllGeofenceListError,
	getAllGeofenceListInIt,
	getAllGeofenceListSuccess,
	deleteGeofenceError,
	deleteGeofenceInit,
	deleteGeofenceSuccess,
	getGeofenceByIdError,
	getGeofenceByIdInIt,
	getGeofenceByIdSuccess,
	addGeofenceError,
	addGeofenceInIt,
	addGeofenceSuccess,
	clearGeofenceDetail,
	updateGeofenceStatusError,
	updateGeofenceStatusInit,
	updateGeofenceStatusSuccess
} = geofenceSlice.actions;
export default geofenceSlice.reducer;
